import React from "react";
import { FunctionComponent } from "react";
import styles from "./ModalWrapper.module.scss";

export const ModalWrapper: FunctionComponent<{}> = ({children}) => {
  return <div className={styles.wrapper}>{children}</div>
}